import { render } from "./kubernetes.svg?vue&type=template&id=8b5bc02e?inline"
const script = {}

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__